import { shade } from "polished";
import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
        'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
        sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: ${props => props.theme.colors.backgroundColor};
  }

  .swal2-container {
    z-index: 99999 !important;
    width: 100% !important;
    .swal2-popup {
      .swal2-title {
        font-size: 26px;
      }
    }

    &.swal2-top > .swal2-popup {
      display: flex !important;
      align-items: center;
      gap: 16px;
      width: 90%;
      max-width: fit-content;
      padding: 16px;
      border: 1px solid #6d318f;
      border-radius: 8px;

      &.error {
        display: flex !important;
        background: #D0434F;
        .swal2-html-container::before {
          content: url("data:image/svg+xml; utf8, <svg width='24' height='24' viewBox='0 0 27 27' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M2.99739 13.9932C2.99739 7.91764 7.92155 2.99348 13.9971 2.99348C20.0727 2.99348 24.9968 7.91764 24.9968 13.9932C24.9968 20.0688 20.0727 24.9929 13.9971 24.9929C7.92155 24.9929 2.99739 20.0688 2.99739 13.9932ZM13.9971 0.99353C6.81701 0.99353 0.997437 6.8131 0.997437 13.9932C0.997437 21.1733 6.81701 26.9929 13.9971 26.9929C21.1772 26.9929 26.9968 21.1733 26.9968 13.9932C26.9968 6.8131 21.1772 0.99353 13.9971 0.99353ZM18.4774 9.51273C18.8679 9.90325 18.8679 10.5364 18.4774 10.9269L15.4113 13.9931L18.4774 17.0592C18.8679 17.4497 18.8679 18.0829 18.4774 18.4734C18.0869 18.8639 17.4538 18.8639 17.0632 18.4734L13.9971 15.4072L10.9309 18.4734C10.5404 18.8639 9.90728 18.8639 9.51676 18.4734C9.12625 18.0829 9.12625 17.4497 9.51676 17.0592L12.5829 13.9931L9.51676 10.9269C9.12625 10.5364 9.12625 9.90325 9.51676 9.51273C9.90728 9.12222 10.5404 9.12222 10.9309 9.51273L13.9971 12.5789L17.0632 9.51273C17.4538 9.12222 18.0869 9.12222 18.4774 9.51273Z' fill='white'/></svg>");
          width: 24px;
          height: 24px;
        }
        &.swal2-toast .swal2-actions button {
          background-color: #D0434F;
        }
      }
      &.success {
        display: flex !important;
        background: #2F334B;
        .swal2-html-container {
          color: #F6F6F6;
          &::before {
            content: url("data:image/svg+xml; utf8, <svg width='24' height='24' viewBox='0 0 27 27' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M2.99433 13.9941C2.99433 7.9185 7.9185 2.99433 13.9941 2.99433C20.0696 2.99433 24.9938 7.9185 24.9938 13.9941C24.9938 20.0696 20.0696 24.9938 13.9941 24.9938C7.9185 24.9938 2.99433 20.0696 2.99433 13.9941ZM13.9941 0.994385C6.81395 0.994385 0.994385 6.81395 0.994385 13.9941C0.994385 21.1742 6.81395 26.9937 13.9941 26.9937C21.1742 26.9937 26.9937 21.1742 26.9937 13.9941C26.9937 6.81395 21.1742 0.994385 13.9941 0.994385ZM20.0344 12.0345C20.4249 11.6439 20.4249 11.0108 20.0344 10.6203C19.6438 10.2298 19.0107 10.2298 18.6202 10.6203L12.6608 16.5797L9.36795 13.2869C8.97744 12.8964 8.34429 12.8964 7.95377 13.2869C7.56326 13.6774 7.56326 14.3105 7.95377 14.7011L11.9537 18.701C12.3442 19.0915 12.9773 19.0915 13.3679 18.701L20.0344 12.0345Z' fill='white'/></svg>");
            width: 24px;
            height: 24px;
          }
        }
        &.swal2-toast .swal2-actions button {
          background-color: ${shade(0.15, "#2F334B")};
          margin: 0;
        }
      }
      &.info {
        display: flex !important;
        background: #fff3cd;
        border: 1px solid #fff3cd;
        .swal2-html-container {
          color: #856404 !important;
          &::before {
            content: url("data:image/svg+xml; utf8, <svg width='24' height='24' viewBox='0 0 27 27' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M13.9971 2.99348C7.92155 2.99348 2.99739 7.91764 2.99739 13.9932C2.99739 20.0688 7.92155 24.9929 13.9971 24.9929C20.0727 24.9929 24.9968 20.0688 24.9968 13.9932C24.9968 7.91764 20.0727 2.99348 13.9971 2.99348ZM13.9971 0.99353C21.1772 0.99353 26.9968 6.8131 26.9968 13.9932C26.9968 21.1733 21.1772 26.9929 13.9971 26.9929C6.81701 26.9929 0.997437 21.1733 0.997437 13.9932C0.997437 6.8131 6.81701 0.99353 13.9971 0.99353ZM13.9971 8.99363C14.5494 8.99363 14.9971 9.44135 14.9971 9.99363V14.9936C14.9971 15.5459 14.5494 15.9936 13.9971 15.9936C13.4448 15.9936 12.9971 15.5459 12.9971 14.9936V9.99363C12.9971 9.44135 13.4448 8.99363 13.9971 8.99363ZM13.9971 17.9936C13.4448 17.9936 12.9971 18.4413 12.9971 18.9936C12.9971 19.5459 13.4448 19.9936 13.9971 19.9936C14.5494 19.9936 14.9971 19.5459 14.9971 18.9936C14.9971 18.4413 14.5494 17.9936 13.9971 17.9936Z' fill='%23856404'/></svg>");
            width: 24px;
            height: 24px;
          }
        }
      }

      &.swal2-toast .swal2-actions {
        margin: 0 !important;
        padding: 0 !important;
        button {
          padding: 8px 16px;
          margin: 0;
        }
      }
    }
  }

  .swal2-popup.swal2-toast .swal2-html-container {
    color: #F6F6F6;
    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.05rem;
    height: 100%;
    display: flex !important;
    align-items: center;
    gap: 16px;
    overflow: hidden;
    margin: 0;
    text-align: center;
    font-family: Open Sans;
    .toast-text {
      display: block;
      display: -webkit-box;
      max-height: 150px;
      -webkit-line-clamp: 5;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`;

export default GlobalStyle;
